// extracted by mini-css-extract-plugin
module.exports = {"container":"Schema_container__VeOfZ","default":"Schema_default__3QxJr","alt":"Schema_alt__2I6f8"};